import { render, staticRenderFns } from "./WindowsOnlyNote.vue?vue&type=template&id=7c77a27f&scoped=true&"
import script from "./WindowsOnlyNote.vue?vue&type=script&lang=ts&"
export * from "./WindowsOnlyNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77a27f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c77a27f')) {
      api.createRecord('7c77a27f', component.options)
    } else {
      api.reload('7c77a27f', component.options)
    }
    module.hot.accept("./WindowsOnlyNote.vue?vue&type=template&id=7c77a27f&scoped=true&", function () {
      api.rerender('7c77a27f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/WindowsOnlyNote.vue"
export default component.exports